import Header from "../Header";
import Footer from "../Footer";
import BreadCrums from "../BreadCrums";
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MetaTag from "../MetaTag";
import { settings } from "../CarosuelsSettings";
import HTMLFlipBook from "react-pageflip";
import TabsComponentFullStack from "./TabsComponentFullStack";
import TabContentComponentFullStack from "./TabContentComponentFullStack";

const FullStackDevelopment = () => {
  const MetaTitle =
    "Full Stack Development Services | Integrated Solutions | Hilton";
  const MetaDescription =
    "Hilton helps you with diverse development needs, starting from simple front end prototyping to complex back end development services. Our full-stack development services are always available at an affordable cost.";
  const MetaKeywords =
    "Full stack application development services, full stack web development, outsource full stack developer";
  const path = window.location.pathname;
  const [activeKey, setActiveKey] = useState('tab1');
  return (
    <>
      <Header />
      <MetaTag
        title={MetaTitle}
        description={MetaDescription}
        keywords={MetaKeywords}
        path={path}
      />
      <BreadCrums
        name={"fullstack"}
        tittle={"Full-stack development services"}
        watermark={"Full-stack development"}
      />
       <div id="" className="fulfill-ecommerce pt-60 pb-60 md-pt-60 md-pb-60 xs-pt-30 xs-pb-30">
        <div className="container-fluid custom">
          <div className="sec-title3 text-center mb-30 md-mb-30">
            <h1 className="title title2 pb-20">
            Comprehensive End-to-End Development Services
            </h1>
            <span className="border-line">
                  <i className="fa fa-diamond" id="diamond"></i>
              </span>
            {/* <div class="bar-main">
                  <div class="bar bar-big"></div>
                </div> */}
          </div>

          <div className="row y-middle text-white">
          <div className="offset-lg-1 col-lg-10 col-md-12">
            <p className="ft16" style={{ textAlign: "center" }}>
            Our team of full-stack consultants conducts in-depth research
                  to assist in the development of a distinctive product that
                  aligns with your business goals. With expertise in testing,
                  continuous integration, and deployment, we ensure seamless
                  compatibility with iOS and Android platforms.
            </p>
            </div>
          </div>
        </div>
      </div>
      <div className="rs-services end-end-fullstack style8 bg-black pt-20 pb-20 md-pt-20 md-pb-20">
        <div className="container-fluid">
          <div className="row y-middle">
            <div className="col-lg-5 pr-25 md-pr-15 md-mb-50">
                <div className="images-part">
                  <img
                    src="/assets/images/web-stack.webp"
                    alt="Images"
                  />
                </div>
            </div>
            <div className="col-lg-7 pl-30 md-pl-15">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="sec-title text-white">
                    <h2 className="title pb-10 text-white">
                      Complete web stack development
                    </h2>
                    <p className="margin-0 pt-15">
                      Our dedicated full-stack development teams specialize in building cutting-edge applications, incorporating risk evaluation, robust testing mechanisms, and more. We are committed to delivering exceptional web and mobile applications tailored to your specific requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 pl-30 md-pl-15">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                <div className="sec-title text-white">
                  <h2 className="title pb-10 text-white">
                    App and system integration
                  </h2>
                  <p className="margin-0 pt-15">
                    We provide professional web API implementation and development services to seamlessly integrate applications and systems, delivering customized web solutions. Our expertise extends to LMS, CMS, ERP, e-commerce, and recruitment solutions.
                  </p>
                </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 pr-25 md-pr-15 md-mb-50">
                <div className="images-part">
                  <img
                    src="/assets/images/system-integration.webp"
                    alt="Images"
                  />
                </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="operational-ecommerce"
        className="rs-single-shop vertical operational-ecommerce full-stack pt-60 pb-60 md-pt-60 sm-pb-60 hidden"
      >
        <div className="container">
          <div className="sec-title text-center mb-55 md-mb-30">
            <h2 className="title title2">
              Our full stack development services
            </h2>
          </div>

          <div id="tab-area-text-roll" className="tab-area">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Fontend-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Fontend"
                  type="button"
                  role="tab"
                  aria-controls="Fontend"
                  aria-selected="true"
                >
                  <img src="/assets/images/icons/front-end.webp" /> Fontend
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Backend-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Backend"
                  type="button"
                  role="tab"
                  aria-controls="Backend"
                  aria-selected="true"
                >
                  <img src="/assets/images/icons/backend.webp" /> Backend
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Databases-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Databases"
                  type="button"
                  role="tab"
                  aria-controls="Databases"
                  aria-selected="true"
                >
                  <img src="/assets/images/icons/databases.webp" /> Databases
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="frameworks-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#frameworks"
                  type="button"
                  role="tab"
                  aria-controls="frameworks"
                  aria-selected="true"
                >
                  <img src="/assets/images/icons/mobile.webp" />
                  Frameworks{" "}
                </button>
              </li>
            </ul>

            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="Fontend"
                role="tabpanel"
                aria-labelledby="Fontend-tab"
              >
                <div className="tab-area">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="HTML-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#HTML"
                        type="button"
                        role="tab"
                        aria-controls="HTML"
                        aria-selected="true"
                      >
                        HTML & Css
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="ReactJS-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#ReactJS"
                        type="button"
                        role="tab"
                        aria-controls="ReactJS"
                        aria-selected="false"
                      >
                        React Js
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="AngularJS-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#AngularJS"
                        type="button"
                        role="tab"
                        aria-controls="AngularJS"
                        aria-selected="false"
                      >
                        Angular Js
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="javascript-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#javascript"
                        type="button"
                        role="tab"
                        aria-controls="javascript"
                        aria-selected="true"
                      >
                        Js
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="vue-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#vue"
                        type="button"
                        role="tab"
                        aria-controls="vue"
                        aria-selected="false"
                      >
                        Vue Js
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="HTML"
                      role="tabpanel"
                      aria-labelledby="HTML-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/Htmlcss2.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">HTML & Css</a>
                          </h3>
                          <p>
                            Our team provides tailored end-to-end front-end
                            development services using CSS and HTML to deliver
                            proficiently designed websites at affordable prices.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="ReactJS"
                      role="tabpanel"
                      aria-labelledby="ReactJS-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/offering-5.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">ReactJS</a>
                          </h3>
                          <p>
                            Our ReactJs development services can help you
                            improve your business performance by delivering
                            modern, highly interactive, and conversion-oriented
                            web applications.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="AngularJS"
                      role="tabpanel"
                      aria-labelledby="AngularJS-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/angular.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">AngularJS</a>
                          </h3>
                          <p>
                            Our AngularJs developers use various frameworks to
                            create powerful, scalable, user-friendly, and
                            easy-to-use web applications based on customer
                            requirements.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="javascript"
                      role="tabpanel"
                      aria-labelledby="javascript-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/jsjquery.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Javascript</a>
                          </h3>
                          <p>
                            Our JavaScript developers deliver high-performance,
                            scalable solutions at high velocity, using proven
                            methodologies and best practices. This empowers
                            businesses to innovate with confidence.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="jquery"
                      role="tabpanel"
                      aria-labelledby="jquery-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/angular.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">jQuery</a>
                          </h3>
                          <p>
                            jQuery is a powerful JavaScript library designed to
                            simplify client-side scripting of HTML. It is known
                            for its speed, conciseness, and flexibility. With a
                            vast collection of libraries available, developers
                            can often avoid writing their own queries. This
                            means that jQuery significantly reduces the amount
                            of code developers need to write. By eliminating the
                            boilerplate, developers can focus solely on
                            project-specific logic, streamlining the development
                            process.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="vue"
                      role="tabpanel"
                      aria-labelledby="vue-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/vue.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">VueJS</a>
                          </h3>
                          <p>
                            Our cost-efficient services provide access to VueJs
                            developers who utilize the latest tools and
                            techniques to deliver innovative solutions,
                            maximizing the value of your investment.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- .tab-area --> */}
              </div>

              <div
                className="tab-pane fade show"
                id="Backend"
                role="tabpanel"
                aria-labelledby="Backend-tab"
              >
                <div className="tab-area">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="PHP-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#PHP"
                        type="button"
                        role="tab"
                        aria-controls="PHP"
                        aria-selected="true"
                      >
                        PHP
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="Laravel-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Laravel"
                        type="button"
                        role="tab"
                        aria-controls="Laravel"
                        aria-selected="false"
                      >
                        Laravel
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="Python-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Python"
                        type="button"
                        role="tab"
                        aria-controls="Python"
                        aria-selected="false"
                      >
                        Python
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="PHP"
                      role="tabpanel"
                      aria-labelledby="PHP-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/php.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">PHP</a>
                          </h3>
                          <p>
                            As a reliable company, we provide unparalleled
                            custom web application development services using
                            PHP. Our experienced team delivers scalable and
                            robust solutions, ranging from dynamic pages to
                            complex ERP systems.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="Laravel"
                      role="tabpanel"
                      aria-labelledby="Laravel-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/laravel.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Laravel</a>
                          </h3>
                          <p>
                            Our veteran team of Laravel developers is dedicated
                            to providing robust, real-time solutions for all
                            your website application development needs using
                            their skills.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="Python"
                      role="tabpanel"
                      aria-labelledby="Python-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/python.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Python</a>
                          </h3>
                          <p>
                            Our python developers are highly skilled in the
                            programming language and standard frameworks,
                            offering robust software development services to
                            companies across various industries.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- .tab-area --> */}
              </div>

              <div
                className="tab-pane fade show"
                id="Databases"
                role="tabpanel"
                aria-labelledby="Databases-tab"
              >
                <div className="tab-area">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="MySql-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#MySql"
                        type="button"
                        role="tab"
                        aria-controls="MySql"
                        aria-selected="true"
                      >
                        MySql
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="PostgreSQL-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#PostgreSQL"
                        type="button"
                        role="tab"
                        aria-controls="PostgreSQL"
                        aria-selected="false"
                      >
                        Postgre SQL
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="MongoDB-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#MongoDB"
                        type="button"
                        role="tab"
                        aria-controls="MongoDB"
                        aria-selected="false"
                      >
                        Mongo DB
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="Elasticsearch-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Elasticsearch"
                        type="button"
                        role="tab"
                        aria-controls="Elasticsearch"
                        aria-selected="true"
                      >
                        Elastic search
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="MySql"
                      role="tabpanel"
                      aria-labelledby="MySql-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/mysql.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">MySql</a>
                          </h3>
                          <p>
                            Our Hilton experts provide elasticsearch services,
                            from development to maintenance. We deliver
                            efficient and tailored search-based business
                            solutions.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="PostgreSQL"
                      role="tabpanel"
                      aria-labelledby="PostgreSQL-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/postgres.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">PostgreSQL</a>
                          </h3>
                          <p>
                            Hilton leverages PostgreSQL's affordability and
                            proficiency, integrating innovative database
                            technologies through our development expertise to
                            enhance our customers' application environment.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="MongoDB"
                      role="tabpanel"
                      aria-labelledby="MongoDB-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/mangodb.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">MongoDB</a>
                          </h3>
                          <p>
                            Our MongoDB developers ensure secure data and
                            deliver professional services tailored to your
                            business needs. MongoDB's features, including
                            monitoring, backup, and optimization, make it the
                            smart choice for managing your data.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="Elasticsearch"
                      role="tabpanel"
                      aria-labelledby="Elasticsearch-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/elesticsearch.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">
                              Elasticsearch
                            </a>
                          </h3>
                          <p>
                            Hilton's elasticsearch experts handle all client
                            needs from development to maintenance. We use
                            elasticsearch's document-oriented approach to create
                            efficient, customized search-based business
                            solutions quickly.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- .tab-area --> */}
              </div>

              <div
                className="tab-pane fade show"
                id="frameworks"
                role="tabpanel"
                aria-labelledby="frameworks-tab"
              >
                <div className="tab-area">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="laravel-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#laravel"
                        type="button"
                        role="tab"
                        aria-controls="laravel"
                        aria-selected="true"
                      >
                        Laravel
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="django-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#django"
                        type="button"
                        role="tab"
                        aria-controls="django"
                        aria-selected="false"
                      >
                        Django
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="codeigniter-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#codeigniter"
                        type="button"
                        role="tab"
                        aria-controls="codeigniter"
                        aria-selected="false"
                      >
                        Code igniter
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="cakephp-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#cakephp"
                        type="button"
                        role="tab"
                        aria-controls="cakephp"
                        aria-selected="false"
                      >
                        Cake PHP
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="laravel"
                      role="tabpanel"
                      aria-labelledby="laravel-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/laravel.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Laravel</a>
                          </h3>
                          <p>
                            Hilton boasts proficient and highly skilled Laravel
                            developers who excel in developing Laravel PHP
                            framework for small and large-scale projects. We
                            provide top-notch and dependable solutions at
                            competitive rates.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="django"
                      role="tabpanel"
                      aria-labelledby="django-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/django.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Django</a>
                          </h3>
                          <p>
                            We are a global django development company that
                            creates solutions promoting quality, adaptability,
                            and an exceptional user experience in today's
                            competitive business environment.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="codeigniter"
                      role="tabpanel"
                      aria-labelledby="codeigniter-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/codeigniter.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">
                              CodeIgniter
                            </a>
                          </h3>
                          <p>
                            Our Codeigniter development creates fast, dynamic
                            websites with result-oriented web applications using
                            PHP framework features.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade show"
                      id="cakephp"
                      role="tabpanel"
                      aria-labelledby="cakephp-tab"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <img src="/assets/images/cakephp.webp" />
                        </div>
                        <div className="col-md-6">
                          <h3 className="h5 font-bold mb-sm">
                            <a className="font-bold text-primary">Cake PHP</a>
                          </h3>
                          <p>
                            At Hilton, our team of experts specializes in
                            CakePHP development services, catering to businesses
                            of all sizes and industries worldwide.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- .tab-area --> */}
              </div>
            </div>
          </div>
          {/* <!-- .tab-area --> */}
        </div>
      </div>

      <div
        id="major-platforms"
        className="major-platforms flipk pt-50 md-pt-40 bg-block"
      >
        <div className="container">
          <div className="sec-title3 text-center mb-55 md-mb-30">
            <h2 className="title title2 pb-20">
              Full Stack Development Services
            </h2>
                <span className="border-line">
                  <i className="fa fa-diamond" id="diamond"></i>
                </span>
            <p className="margin-0 text-white">
              Come and choose your specific business requirements from our pool
              of expert solutions.
            </p>
            {/* <div class="bar-main">
                  <div class="bar bar-big"></div>
             </div> */}
          </div>
        </div>
      </div>
      <div
        id="ecom-platforms"
        className="ecom-platforms flipk"
      >
          <div className="container-fluid mt-4">
            <TabsComponentFullStack activeKey={activeKey} onSelect={setActiveKey} />
          </div>
          <div>
          <TabContentComponentFullStack activeKey={activeKey} />
          </div>
      </div>
      <div
        id="process-steps"
        className="mob-dev style4 pt-60 pb-60 md-pt-60 md-pb-60 xs-pt-30 xs-pb-30"
      >
        <div className="container-fluid">
          <div className="sec-title3 text-center mb-60">
            <h2 className="title title2 pb-20">
              Full Stack Development Process
            </h2>
                 <span className="border-line">
                  <i className="fa fa-diamond" id="diamond"></i>
                  </span>
            {/* <div class="bar-main">
                  <div class="bar bar-big"></div>
             </div> */}
          </div>

          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="process-steps">
                <div className="process-item bottom">
                    <div className="pt-150 sm-pt-0"></div>
                    <div className="icon-wrapper">
                        <span>
                            <img loading="lazy" decoding="async" width="95" height="95" src="/assets/images/design-thinking.webp" className="attachment-full dance_hover" alt="Design & Wireframing" title="Design & Wireframing" />
                        </span>
                    </div>
                    <div className="process-content">
                      <h3 className="title">Design & Wireframing</h3>
                      <p>Our UX/UI designers create intuitive app designs that prioritize user engagement and seamless navigation, ensuring your app stands out.</p>
                    </div>
               </div>
               <div className="process-item top">
                    <div className="icon-wrapper reverse">
                        <span>
                            <img loading="lazy" decoding="async" width="95" height="95" src="/assets/images/development.webp" className="attachment-full dance_hover" alt="Development" title="Development" />
                        </span>
                    </div>
                    <div className="process-content">
                      <h3 className="title">Development</h3>
                      <p>Our developers build the app using the latest technologies, ensuring fast load times, smooth transitions, and an optimized mobile experience.</p>
                    </div>
               </div>
               <div className="process-item bottom">
                   <div className="pt-150 sm-pt-0"></div>
                    <div className="icon-wrapper">
                        <span>
                            <img loading="lazy" decoding="async" width="95" height="95" src="/assets/images/qa.webp" className="attachment-full dance_hover" alt="Quality Assurance & Testing" title="Quality Assurance & Testing" />
                        </span>
                    </div>
                    <div className="process-content">
                      <h3 className="title">Quality Assurance & Testing</h3>
                      <p>Rigorous testing is conducted to ensure the app performs well across different devices and operating systems, guaranteeing a bug-free user experience.</p>
                    </div>
               </div>
               <div className="process-item">
                    <div className="icon-wrapper reverse">
                        <span>
                            <img loading="lazy" decoding="async" width="95" height="95" src="/assets/images/startup.webp" className="attachment-full dance_hover" alt="Launch & Support" title="Launch & Support" />
                        </span>
                    </div>
                    <div className="process-content">
                      <h3 className="title">Launch & Support</h3>
                      <p>Post-launch, we provide ongoing updates and support to ensure the app remains up-to-date with the latest features and security standards.</p>
                    </div>
               </div>
               </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="business-gain-by-choosing-Full-stack"
        className="rs-faq  pt-60 pb-60 md-pt-60 sm-pb-60 hidden"
      >
        <div className="container">
          <div className="sec-title text-center mb-55 md-mb-30">
            <h2 className="title title2 pb-20">
              What can your business gain by choosing Full-stack development
              services?
            </h2>
            <div class="bar-main">
                  <div class="bar bar-big"></div>
                </div>
            <p className="margin-0">
              By opting for our Full stack development services, you can
              leverage the technical expertise and capabilities of our
              programmers in all aspects of website and application development.
              They are skilled in object-oriented design, development, patterns,
              and methodologies, ensuring top-notch results for your project.
            </p>
          </div>

          <div className="faq-content">
            <div id="accordion" className="accordion">
              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <a
                        className="card-link collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                      >
                        Agile methodology
                      </a>
                    </div>
                    <div
                      id="collapseOne"
                      className="collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        This approach enables incremental improvements to each
                        product component, facilitating gradual scaling until
                        the final product is achieved. Moreover, the ongoing
                        review and testing processes throughout each stage
                        ensure a final output that is error-free.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">
                      <a
                        className="card-link collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                      >
                        Improved support and maintenance
                      </a>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        Our team of full-stack developers provides continuous
                        support and maintenance, staying up-to-date with
                        emerging technologies across multiple domains and
                        readily adapting to evolving conditions.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">
                      <a
                        className="card-link collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                      >
                        Rapid development
                      </a>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        Full-stack web development enables efficient project
                        completion, rapid time-to-market, and seamless
                        collaboration across all development stages. This
                        eliminates dependencies on other teams and minimizes
                        delays caused by frontend-back-end dependencies.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <a
                        className="card-link collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                      >
                        Efficient trouble shooting
                      </a>
                    </div>
                    <div
                      id="collapseFour"
                      className="collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        Effective troubleshooting entails identifying and
                        resolving development setbacks and post-release
                        maintenance issues caused by external factors. Hiring a
                        full-stack developer is advantageous in addressing both
                        challenges, as they possess expertise in resolving
                        various issues and have knowledge of relevant
                        algorithms.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">
                      <a
                        className="card-link collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                      >
                        Enhanced flexibility
                      </a>
                    </div>
                    <div
                      id="collapseFive"
                      className="collapse"
                      data-bs-parent="#accordion"
                    >
                      <div className="card-body">
                        Full-stack developers possess broad expertise in diverse
                        technologies, allowing them to adapt quickly to any
                        situation throughout the software development lifecycle
                        and seamlessly fill in for team members as needed.
                        Consequently, organizations can greatly benefit from the
                        enhanced flexibility provided by full-stack development
                        services.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


   


      {/* <div id="Full-stack-portfolio" className="pt-60 pb-30 md-pt-60 sm-pb-60">
        <div className="container">
          <div className="sec-title text-center mb-55 md-mb-30">
            <h2 className="title title2">Full-stack portfolio</h2>
          </div>
          <Slider {...settings}>
            <div className="service-wrap">
              <div className="row y-middle">
                <div className="col-lg-6 pr-70 md-pr-15 md-mb-50">
                  <div className="sec-title2 mb-30">
                    <h2 className="title mb-23">PMI-PCC</h2>
                    <p className="desc mb-0">
                      <b>About:</b>PMI Pearl City, Hyderabad Chapter is a
                      professional project management membership organization in
                      Hyderabad, India. PMIPCC organizes various in-person and
                      virtual events round the year. Develop lasting
                      relationships, engage with experts, share best practices
                      and gain practical insights.
                    </p>
                    <br />
                    <p className="desc mb-0">
                      <b>Business Need:</b>PMIPCC offers workshops that delivers
                      PMI certification preparatory courses and customized
                      courses on project management either in person or virtual.
                      These courses are designed to aid professional development
                      of people at all stages of their career.
                    </p>
                    <div className="btn-part pt-30">
                      <a
                        className="readon consultant discover"
                        href="https://pmi-pcc.org/"
                        target="_blank"
                      >
                        Discover More
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="about-img">
                    <a href="https://pmi-pcc.org/" target="_blank">
                      <img
                        src="/assets/images/portfolio/pmipcc-fullstack.webp"
                        alt="images"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="service-wrap">
              <div className="row y-middle">
                <div className="col-lg-6 pr-70 md-pr-15 md-mb-50">
                  <div className="sec-title2 mb-30">
                    <h2 className="title mb-23">Desi OPT World</h2>
                    <p className="desc mb-0">
                      A leading career & recruitment portal, ever since it has
                      been guiding and mentoring international students to craft
                      a career in area of study. With its cutting edge
                      technology provides relevant profiles to employers and
                      relevant jobs to jobseekers across industry verticals.
                    </p>
                    <br />
                    <p className="desc mb-0">
                      To develop online job portal which acts as matchmaker
                      between the candidates and the employers. Where Employers
                      can post jobs and candidates have free access to millions
                      of jobs from thousands of company websites and job boards.
                    </p>
                    <div className="btn-part pt-30">
                      <a
                        className="readon consultant discover"
                        href="https://desioptjobs.com/optworld"
                        target="_blank"
                      >
                        Discover More
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="about-img">
                    <a href="https://desioptjobs.com/optworld" target="_blank">
                      <img
                        src="/assets/images/portfolio/desiopt-fullstack.webp"
                        alt="images"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div> */}


      <div id="Full-stack-portfolio" className="pt-60 pb-30 md-pt-60 sm-pb-60 xs-pt-30 xs-pb-30 bg-black">
          <div className="container">
          <div className="sec-title3 text-center mb-30 md-mb-30">
            <h2 className="title title2 pb-20">Full Stack Portfolio</h2>
                <span className="border-line">
                  <i className="fa fa-diamond" id="diamond"></i>
                  </span>
              {/* <div class="bar-main">
                  <div class="bar bar-big"></div>
              </div> */}
          </div>
              <div className="book-wrapper">
              <HTMLFlipBook
                width={500}
                height={600}
                size="stretch"
                startPage={1}  // Start with the first page open
                showCover={false}
                maxShadowOpacity={0.5}
                className="book-container"
              >
                {/* <div className="cover1 page1">
                  <h1>Full-Stack portfolio</h1>
                  <div className="btn-wrap mt-50 mb-20 page-flip-marker">
                            <a
                              target="_self"
                              className="fl-button"
                              tabIndex="0"
                              previewlistener="true"
                            >
                              <span className="fl-button-text">See Our Portfolio</span>
                              <i className="fl-button-icon fl-button-icon-after fa fa-long-arrow-right"></i>
                            </a>
                    </div>
                </div> */}
                <div className="page1">
                  <div className="service-wrap">
                          <div className="client-logo">
                          <h2>PMI-PCC</h2>
                            <img
                              src="/assets/images/brands/Picture20.webp"
                              alt="images"
                            />
                          </div>
                          <div className="client-banner">
                            <img
                              src="/assets/images/portfolio/pmipcc-fullstack.webp"
                              alt="images"
                            />
                          </div>
                  </div>
                </div>
                {/* <div className="page1">
                    <div className="about-img">
                            <img
                              src="/assets/images/portfolio/pmipcc-fullstack.webp"
                              alt="images"
                            />
                     </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}
                <div className="page1">
                  <div className="service-wrap">
                      <div className="client-logo">
                      <h2>Desi OPT World</h2>
                            <img
                              src="/assets/images/brands/Picture19.webp"
                              alt="images"
                            />
                          </div>
                          <div className="client-banner">
                            <img
                              src="/assets/images/portfolio/desiopt-fullstack.webp"
                              alt="images"
                            />
                          </div>
                  </div>
                  <div className="page-flip-marker">→</div>
                </div>
                {/* <div className="page1">
                  <div className="about-img">
                      <img
                        src="/assets/images/portfolio/desiopt-fullstack.webp"
                        alt="images"
                      />
                  </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}
                {/* <div className="page1">
                <div className="service-wrap">
                  <div className="sec-title2 mb-30">
                    <h2 className="title mb-23">Member Traxx</h2>
                    <p className="desc mb-0"></p>
                    <b>About:</b> Member TRAXX is a versatile platform designed to empower groups, teams, facilities, organizations, and businesses by simplifying the management of memberships, registrations, and financial transactions. It offers a flexible solution tailored to the unique needs of various sports and group activities. Users are provided with their own space in the Member Traxx Multi Tenant Environment
                    <br />
                    <p className="desc mb-0">
                      <b>Business need:</b> Managing diverse group needs and requirements across different sports and activities.
Providing a flexible system that supports various types of memberships, lessons, and events.
Efficiently handling registrations, payments, and user permissions.
                    </p>
              </div>
            </div>
                  <div className="page-flip-marker">←</div>
                </div> */}
                {/* <div className="page1">
                  <div className="about-img">
                      <img
                        src="/assets/images/portfolio/membertraxx.webp"
                        alt="images"
                      />
                  </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}
                <div className="page1">
                <div className="service-wrap">
                    <div className="client-logo">
                      <h2>Player Pulse</h2>
                            <img
                              src="/assets/images/brands/player-pulse.webp"
                              alt="images"
                            />
                          </div>
                          <div className="client-banner">
                            <img
                              src="/assets/images/portfolio/playerpulse.webp"
                              alt="images"
                            />
                          </div>
            </div>
            <div className="page-flip-marker">←</div>
                </div>
                {/* <div className="page1">
                  <div className="about-img">
                      <img
                        src="/assets/images/portfolio/fhithockey.webp"
                        alt="images"
                      />
                  </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}

                {/* <div className="page1">
                  <div className="service-wrap">
                    <div className="sec-title2 mb-30">
                      <h2 className="title mb-23">StudyWise</h2>
                      <p className="desc mb-0"></p>
                      <b>About:</b> FHIT Hockey delivers comprehensive hockey programs, clinics, and training services with a focus on individual player development and performance. Our flexible schedule and expert coaching create an engaging environment for hockey enthusiasts.
                      <br />
                      <p className="desc mb-0">
                        <b>Business need:</b> Providing high-quality, flexible training programs that cater to varying skill levels and schedules.
                          Ensuring a continuous, motivational experience for athletes.
                          Offering specialized training in human performance and skill development.
                      </p>
                    </div>
                  </div>
                  <div className="page-flip-marker">←</div>
                </div> */}
                {/* <div className="page1">
                  <div className="about-img">
                      <img
                        src="/assets/images/portfolio/studywise.webp"
                        alt="images"
                      />
                  </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}
                <div className="page1">
                  <div className="service-wrap">
                  <div className="client-logo">
                      <h2>Midwest Group</h2>
                            <img
                              src="/assets/images/brands/midwest_group.webp"
                              alt="images"
                            />
                          </div>
                          <div className="client-banner">
                            <img
                              src="/assets/images/portfolio/midwestgroup.webp"
                              alt="images"
                            />
                          </div>
                  </div>
                </div>
                {/* <div className="page1">
                  <div className="about-img">
                      <img
                        src="/assets/images/portfolio/Midwest.webp"
                        alt="images"
                      />
                  </div>
                  <div className="page-flip-marker">➔</div>
                </div> */}
                {/* <div className="back-cover1 page1">
                  <h1>Full-Stack Portfolio</h1>
                  <p>Thank you for reading!</p>
                  <div className="btn-wrap mt-50 mb-20">
                            <a
                              target="_self"
                              className="fl-button"
                              href="/contact"
                              tabIndex="0"
                              previewlistener="true"
                            >
                              <span className="fl-button-text">Contact Us</span>
                              <i className="fl-button-icon fl-button-icon-after fa fa-long-arrow-right"></i>
                            </a>
                    </div>
                </div> */}
              </HTMLFlipBook>
        </div>
         </div>
    </div>

      <Footer />
    </>
  );
};

export default FullStackDevelopment;
